import React from 'react';
import { SNELKNOP_KLEUREN } from './snelknoppenCatalogus';

// Gedeelde editor: aantal (4/8), tegels kiezen, volgorde, kleur. Geen eigen opslag.
export function SnelknopTegel({ item, kleur, klein }) {
  const bg = SNELKNOP_KLEUREN[kleur] || null;
  return (
    <div style={{
      background: bg || '#ffffff', border: '1px solid ' + (bg || '#e2e8f0'), borderRadius: 12,
      padding: klein ? '8px 2px' : '12px 4px', color: bg ? '#ffffff' : '#1e293b', textAlign: 'center', minWidth: 0
    }}>
      <div style={{ fontSize: klein ? 16 : 20 }}>{item ? item.icon : ''}</div>
      <div style={{ fontSize: klein ? 10 : 12, fontWeight: 600, marginTop: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {item ? item.label : ''}
      </div>
    </div>
  );
}

export default function SnelknoppenEditor({ catalogus, waarde, onChange }) {
  const byId = Object.fromEntries(catalogus.map(i => [i.id, i]));
  const tegels = (waarde.tegels || []).filter(t => byId[t.id]);
  const aantal = waarde.aantal === 8 ? 8 : 4;
  const zet = (nieuw) => onChange({ aantal, tegels, ...nieuw });

  const verplaats = (idx, richting) => {
    const l = [...tegels]; const j = idx + richting;
    if (j < 0 || j >= l.length) return;
    [l[idx], l[j]] = [l[j], l[idx]]; zet({ tegels: l });
  };
  const verwijder = (idx) => { const l = [...tegels]; l.splice(idx, 1); zet({ tegels: l }); };
  const voegToe = (id) => { if (tegels.length >= aantal) return; zet({ tegels: [...tegels, { id, kleur: 'standaard' }] }); };
  const kleur = (idx, k) => { const l = [...tegels]; l[idx] = { ...l[idx], kleur: k }; zet({ tegels: l }); };
  const beschikbaar = catalogus.filter(i => !tegels.some(t => t.id === i.id));

  const knop = { border: '1px solid #e2e8f0', background: '#fff', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: 14 };

  return (
    <div>
      {/* Aantal */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        {[4, 8].map(n => (
          <button key={n} type="button" onClick={() => zet({ aantal: n, tegels: tegels.slice(0, n) })} style={{
            flex: 1, padding: 10, borderRadius: 10, fontWeight: 700, cursor: 'pointer',
            border: '2px solid ' + (aantal === n ? '#2563eb' : '#e2e8f0'), background: aantal === n ? '#2563eb' : '#fff', color: aantal === n ? '#fff' : '#1e293b'
          }}>{n} tegels</button>
        ))}
      </div>

      {/* Voorbeeld */}
      <div style={{ fontSize: 12, color: '#64748b', marginBottom: 6 }}>Voorbeeld</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginBottom: 16, background: '#f1f5f9', padding: 10, borderRadius: 12 }}>
        {Array.from({ length: aantal }).map((_, i) => tegels[i]
          ? <SnelknopTegel key={i} item={byId[tegels[i].id]} kleur={tegels[i].kleur} klein />
          : <div key={i} style={{ border: '1px dashed #cbd5e1', borderRadius: 12, minHeight: 52 }} />)}
      </div>

      {/* Gekozen */}
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 6 }}>Gekozen ({tegels.length}/{aantal})</div>
      {tegels.map((t, idx) => (
        <div key={t.id} style={{ border: '1px solid #e2e8f0', borderRadius: 10, padding: 8, marginBottom: 6, background: '#fff' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <span style={{ fontSize: 18 }}>{byId[t.id].icon}</span>
            <span style={{ flex: 1, fontWeight: 600 }}>{byId[t.id].label}</span>
            <button type="button" style={knop} disabled={idx === 0} onClick={() => verplaats(idx, -1)}>↑</button>
            <button type="button" style={knop} disabled={idx === tegels.length - 1} onClick={() => verplaats(idx, 1)}>↓</button>
            <button type="button" style={{ ...knop, color: '#dc2626' }} onClick={() => verwijder(idx)}>✕</button>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 8 }}>
            {Object.entries(SNELKNOP_KLEUREN).map(([k, hex]) => (
              <button key={k} type="button" title={k} onClick={() => kleur(idx, k)} style={{
                width: 26, height: 26, borderRadius: '50%', cursor: 'pointer', padding: 0,
                background: hex || '#ffffff', border: t.kleur === k ? '3px solid #0f172a' : '1px solid #cbd5e1',
                boxShadow: t.kleur === k ? '0 0 0 2px #fff inset' : 'none'
              }} />
            ))}
          </div>
        </div>
      ))}

      {/* Beschikbaar */}
      <div style={{ fontSize: 13, fontWeight: 700, margin: '14px 0 6px' }}>
        Toevoegen {tegels.length >= aantal ? <span style={{ fontWeight: 400, color: '#64748b' }}>(vol — haal er eerst een weg)</span> : null}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))', gap: 6 }}>
        {beschikbaar.map(i => (
          <button key={i.id} type="button" disabled={tegels.length >= aantal} onClick={() => voegToe(i.id)} style={{
            ...knop, textAlign: 'left', opacity: tegels.length >= aantal ? 0.45 : 1
          }}>{i.icon} {i.label}</button>
        ))}
      </div>
    </div>
  );
}
